declare namespace $ {

	type $mol_list__rows_bog_vmap_app_layers_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__attr_bog_vmap_app_layers_2 = $mol_type_enforce<
		({ 
			'bog_vmap_app_layers_line_zone': ReturnType< $bog_vmap_app_layers['row_zone'] >,
			'bog_vmap_app_layers_line_shade': ReturnType< $bog_vmap_app_layers['row_shade'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_bog_vmap_app_layers_3 = $mol_type_enforce<
		({ 
			dragover( next?: ReturnType< $bog_vmap_app_layers['row_over'] > ): ReturnType< $bog_vmap_app_layers['row_over'] >,
		})  & ReturnType< $mol_view['event'] >
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_vmap_app_layers_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_drop__allow_bog_vmap_app_layers_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_drop['allow'] >
	>
	type $mol_drop__adopt_bog_vmap_app_layers_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_adopt'] >
		,
		ReturnType< $mol_drop['adopt'] >
	>
	type $mol_drop__receive_bog_vmap_app_layers_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_receive'] >
		,
		ReturnType< $mol_drop['receive'] >
	>
	type $mol_drop__Sub_bog_vmap_app_layers_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['Line'] >
		,
		ReturnType< $mol_drop['Sub'] >
	>
	type $bog_vmap_lang_doc__source_bog_vmap_app_layers_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['source'] >
		,
		ReturnType< $bog_vmap_lang_doc['source'] >
	>
	type $mol_status__status_bog_vmap_app_layers_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['node_title_note'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_check_expand__level_bog_vmap_app_layers_11 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_check_expand['level'] >
	>
	type $mol_check_expand__title_bog_vmap_app_layers_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_expand['title'] >
	>
	type $mol_check_expand__expanded_bog_vmap_app_layers_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['outside_expanded'] >
		,
		ReturnType< $mol_check_expand['expanded'] >
	>
	type $mol_drag__allow_copy_bog_vmap_app_layers_14 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_drag['allow_copy'] >
	>
	type $mol_drag__allow_link_bog_vmap_app_layers_15 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_drag['allow_link'] >
	>
	type $mol_drag__attr_bog_vmap_app_layers_16 = $mol_type_enforce<
		({ 
			'draggable': ReturnType< $bog_vmap_app_layers['row_draggable'] >,
		})  & ReturnType< $mol_drag['attr'] >
		,
		ReturnType< $mol_drag['attr'] >
	>
	type $mol_drag__transfer_bog_vmap_app_layers_17 = $mol_type_enforce<
		({ 
			'text/plain': ReturnType< $bog_vmap_app_layers['row_name'] >,
		})  & ReturnType< $mol_drag['transfer'] >
		,
		ReturnType< $mol_drag['transfer'] >
	>
	type $mol_drag__Sub_bog_vmap_app_layers_18 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['Row_drop'] >
		,
		ReturnType< $mol_drag['Sub'] >
	>
	type $mol_check_expand__level_bog_vmap_app_layers_19 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_level'] >
		,
		ReturnType< $mol_check_expand['level'] >
	>
	type $mol_check_expand__expanded_bog_vmap_app_layers_20 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_expanded'] >
		,
		ReturnType< $mol_check_expand['expanded'] >
	>
	type $mol_check__Icon_bog_vmap_app_layers_21 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_icon'] >
		,
		ReturnType< $mol_check['Icon'] >
	>
	type $mol_check__title_bog_vmap_app_layers_22 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_title'] >
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__hint_bog_vmap_app_layers_23 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_hint'] >
		,
		ReturnType< $mol_check['hint'] >
	>
	type $mol_check__checked_bog_vmap_app_layers_24 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_picked'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__click_bog_vmap_app_layers_25 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_pick'] >
		,
		ReturnType< $mol_check['click'] >
	>
	type $mol_check__clicks_bog_vmap_app_layers_26 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_edit'] >
		,
		ReturnType< $mol_check['clicks'] >
	>
	type $mol_string__hint_bog_vmap_app_layers_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_vmap_app_layers_28 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_vmap_app_layers_29 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_layers['row_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_bog_vmap_app_layers_30 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $bog_vmap_app_layers['row_submit'] > ): ReturnType< $bog_vmap_app_layers['row_submit'] >,
			keydown( next?: ReturnType< $bog_vmap_app_layers['row_key'] > ): ReturnType< $bog_vmap_app_layers['row_key'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	export class $bog_vmap_app_layers extends $mol_scroll {
		rows( ): readonly($mol_view)[]
		Rows( ): $mol_list
		outside_expanded( next?: boolean ): boolean
		row_draggable( id: any): boolean
		row_name( id: any): string
		row_adopt( next?: any ): any
		row_receive( id: any, next?: any ): any
		row_zone( id: any, next?: string ): string
		row_shade( id: any): string
		row_over( id: any, next?: any ): any
		row_content( id: any): readonly($mol_view)[]
		Line( id: any): $mol_view
		Row_drop( id: any): $mol_drop
		row_level( id: any): number
		row_expanded( id: any, next?: boolean ): boolean
		row_icon( id: any): any
		row_title( id: any): string
		row_hint( id: any): string
		row_picked( id: any): boolean
		row_pick( id: any, next?: any ): any
		row_edit( id: any, next?: any ): any
		row_draft( id: any, next?: string ): string
		row_submit( id: any, next?: any ): any
		row_key( id: any, next?: any ): any
		source( ): string
		root( ): string
		doc_key( ): string
		picked( next?: readonly(string)[] ): readonly(string)[]
		inner( next?: string ): string
		inner_kids( id: any): readonly(string)[]
		inner_class( id: any): string
		inner_alien( id: any): boolean
		node_title( next?: string ): string
		node_title_note( ): string
		tree_move( next?: any ): any
		node_show( next?: any ): any
		editable( ): boolean
		Doc( ): $bog_vmap_lang_doc
		sub( ): readonly(any)[]
		Note( ): $mol_status
		Outside( ): $mol_check_expand
		Row( id: any): $mol_drag
		Expand( id: any): $mol_check_expand
		Pick( id: any): $mol_check
		Edit( id: any): $mol_string
		Root_icon( ): $mol_icon_file_document_outline
		Frame_icon( id: any): $mol_icon_artboard
		Image_icon( id: any): $mol_icon_image
		Link_icon( id: any): $mol_icon_link
		Button_icon( id: any): $mol_icon_button_cursor
		Field_icon( id: any): $mol_icon_form_textbox
		Text_icon( id: any): $mol_icon_format_text
		Part_icon( id: any): $mol_icon_shape_outline
	}
	
}

//# sourceMappingURL=layers.view.tree.d.ts.map